import { Amplitude, Events } from '@iwoca/frontend-tracking-library';
import { useLocale } from './useLocale';

type TOptions = {
  includePageData: boolean;
};

export function useAmplitude() {
  const { locale } = useLocale();

  const trackEvent = (
    event: string,
    payload?: {
      [key: string]: string | number | boolean | null;
    },
    options: TOptions = { includePageData: true },
  ) => {
    if (options.includePageData) {
      payload = {
        'Page name': document.title,
        URL: window.location.pathname,
        ...(payload || {}),
      };
    }
    Amplitude.track(
      Events.introducerPortal.introducerPortalEventCreator({
        event,
        locale,
        payload,
      }),
    );
  };

  return {
    trackEvent,
  };
}
